<template>
  <div>
    <div :class="$style.dropShop">
      <div style="$style.dropShopEntry">
        <div>{{ dropShop.name }}</div>
        <div :class="$style.dropShopAddress">
          <span :class="$style.dropShopDistance">{{ dropShop.distance | distance }}</span>
          ({{ dropShop.address.street.replace("null", "") }}, {{ dropShop.address.zipCode.replace("null", "") }}, {{ dropShop.address.city.replace("null", "") }})
        </div>

        <div
          v-if="dropShop.openingHoursSummary && dropShop.openingHoursSummary.length"
          :class="['c-cbr-MapOverlay-dropShopOpeningHours', $style.row]"
        >
          <cbr-drop-shop-opening-hours
            :drop-shop="dropShop"
            :style="{'margin-bottom': '1rem'}"
          />
        </div>
      </div>

      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 100 100"
        width="90"
        height="90">
        <rect
          id="pin"
          x="0"
          y="0"
          width="27.143"
          height="38"
          style="fill:none;" />
        <clipPath id="_clip1">
          <rect
            x="0"
            y="0"
            width="27.143"
            height="38" />
        </clipPath>
        <g clip-path="url(#_clip1)">
          <g
            id="pin1"
            serif:id="pin">
            <rect
              id="EXPORT"
              x="-2352.67"
              y="-1805.5"
              width="6611.8"
              height="5215.4"
              style="fill:none;"
            />
            <path
              :style="getFillStyle()"
              d="M13.6,0.5c-7.242,0 -13.1,5.745 -13.1,12.848c0,9.636 13.1,23.861 13.1,23.861c0,0 13.1,-14.225 13.1,-23.861c0,-7.103 -5.858,-12.848 -13.1,-12.848Z"
            />
          </g>
        </g>
      </svg>
    </div>
  </div>
</template>

<script>
import CbrDropShopOpeningHours from './drop-shop/CbrDropShopOpeningHours.vue'
import { mapGetters } from 'vuex'
export default {
  components: { CbrDropShopOpeningHours },

  props: {
    dropShop: {
      type: Object,
      required: true
    }
  },
  computed: {
    ...mapGetters('config', ['buttonColor'])
  },

  methods: {
    getOpeningSummary(dropShop) {
      return dropShop.openingHoursSummary
        .replace(/\|([^#])/g, '|----| $1')
        .split('|----|')
        .map(entry => {
          const [day, hoursStr] = entry.replace(":#",": #").split(': ', 2)
          const hours = hoursStr.split(/\|?#/)
          return { day, hours }
        })
    },
    getFillStyle() {
      if (this.buttonColor !== '') {
        return (
          'fill:' +
          this.buttonColor +
          ';fill-rule:nonzero;stroke:' +
          this.buttonColor +
          ';stroke-width:1px;'
        )
      } else
       return 'fill:#6b1544;fill-rule:nonzero;stroke:#6b1544;stroke-width:1px;'
    }
  }
}
</script>

<style module>

.dropShop {
  display: grid;
  grid-gap: 0.5em 0.5em;
  grid-template-columns: 1fr 40px;
}

.dropShopEntry {
  float: left;
  width: 80%;
}

.dropShopAddress {
  overflow: hidden;
  text-overflow: ellipsis;
}

.dropShopDistance {
  font-weight: bold;
  display: inline;
}

.row {
  margin-top: 0.5em;
}

.shopIcon {
  max-height: 50px;
  max-width: auto;
}
</style>



// WEBPACK FOOTER //
// client/components/CbrDropShop.vue